import Grid from "@mui/material/Grid";
import MssIcon from "../../common/MssIcon";

const AiGateHelp = () => {
  return (
    <>
      <Grid container flexDirection={"column"} alignItems="center">
        <span className="title" style={{ textAlign: "center", marginTop: "84px" }}>
          등록이 완료되었습니다 <br />
          이제 피플카운트 시스템을 사용해볼까요?
        </span>
        <span style={{ marginTop: "13px" }}>GATE 센서를 이용해 실내 공간의 유동인구를 비교하고 분석할 수 있습니다</span>
      </Grid>

      <Grid container display={"flex"} marginTop={"67px"}>
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid container alignItems={"center"} justifyContent="center">
            <Grid item md={3}>
              <MssIcon name="GATE_3D-help" className="sensor-model" />
            </Grid>
            <Grid item md={6} display={"flex"} flexDirection={"column"} sx={{ color: "#7D88B0" }}>
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>[올바른 센서 설치 안내]</span>
              <ul style={{ marginTop: "13px" }}>
                <li>
                  문밖에서 <b>TX</b> 센서를 왼쪽에 설치하고 <b>RX</b> 센서가 오른쪽에 설치하면 들어갈 때 <b>IN</b>, 나갈
                  때 <b>OUT</b>으로 측정됩니다.
                </li>
                <br />
                <li>사람의 가슴높이즘에 마주보게 설치하면 센서가 보다 잘 인식됩니다</li>
              </ul>
              <span style={{ marginTop: "13px" }}>※ 사람 손이 잘 닿이지 않는 문 위쪽에 설치하는걸 추천드립니다!</span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AiGateHelp;
